import axios from "axios";

// Keys a JWT might be stored under. The first one that holds a value wins.
const TOKEN_KEYS = ["token", "accessToken", "authToken", "jwt"];

const getToken = () => {
  for (const key of TOKEN_KEYS) {
    const value = localStorage.getItem(key) || sessionStorage.getItem(key);
    if (value && value !== "null" && value !== "undefined") {
      return value.replace(/^"|"$/g, ""); // strip quotes if it was JSON.stringify'd
    }
  }

  // Fallback: token stored inside the "user" object
  try {
    const user = JSON.parse(localStorage.getItem("user"));
    return user?.token || user?.accessToken || null;
  } catch {
    return null;
  }
};

const http = axios.create();

http.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    console.warn(
      "[http] No JWT found in storage — request to",
      config.url,
      "will be rejected. Checked keys:",
      TOKEN_KEYS.join(", "),
      "and user.token"
    );
  }
  return config;
});

export default http;